// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"d09b1d7d","919":"0779a6da"}[chunkId] + ".chunk.js";
};